<template>
  <div v-loading="fullscreenLoading">
    <div style="margin-left:10.5%;overflow:hidden">
      <div style="padding:20px 20px 20px 0px">
        <div
          @click="onGoTo('home')"
          style="padding:10px;font-size:20px;color:#1bb24b;font-weight:bold;display:inline-block;cursor:pointer"
        >店铺信息</div>
        <div
          v-if="boolOrderProduct"
          style="display:inline-block;vertical-align:middle;cursor:pointer"
        >
          <img style="width:20px;height:20px;" src="../assets/arrow-right.png" />
        </div>
        <div
          v-if="boolOrderProduct"
          style="padding:10px;font-size:20px;color:#1bb24b;font-weight:bold;display:inline-block;cursor:pointer"
        >下单商品</div>
      </div>


      <!-- home -->
      <div
        v-if="!boolOrderProduct"
        class="Rectangle-5"
        v-bind:style="{ height:  + (windowHeight-200) + 'px' }"
      >
        <div style="padding:3%;">
          <div style>
            <div style="display:inline-block;width:70%;">
              <el-date-picker
                v-model="searchAllDate"
                value-format="yyyy-MM-dd"
                style="display:inline-block;vertical-align:middle;"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @keyup.enter.native="onSearchTableData"
              ></el-date-picker>
              <el-input
                style="display:inline-block;width:35%;margin-left:10px;vertical-align:middle"
                v-model="searchKeyword"
                placeholder="请输入店铺名称"
                @keyup.enter.native="onSearchTableData"
              ></el-input>
              <el-button
                @click="onSearchTableData"
                style="display:inline-block;margin-left:20px;background-color:#1bb24b"
                type="success"
              >搜索</el-button>
            </div>
            <div style="display:inline-block;text-align:right;width:30%">
              <div style="display:inline-block;text-align:right;margin-right:10px">
                <el-button
                  @click="onDialogboolAddNewOpen()"
                  style="color:#1bb24b;border-color:#1bb24b"
                >添加新店铺</el-button>

                <el-button
                  @click="onDialogBoolDownloadAllExcelOpen()"
                  style="color:#1bb24b;border-color:#1bb24b"
                >导出店铺总Excel</el-button>
              </div>
            </div>
          </div>

          <div style="margin-top:3%;">
            <el-table :data="tableDataList" :height="windowHeight-450" style="width: 100%" stripe>
              <el-table-column prop="id" label="ID" sortable width="100"></el-table-column>
              <el-table-column prop="name" label="店铺名称" width="200"></el-table-column>
              <el-table-column prop="phone" label="电话"></el-table-column>
              <el-table-column prop="address" label="地址"></el-table-column>
              <el-table-column prop="status" label="状态"></el-table-column>

              <el-table-column label="操作" width="300">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="small"
                    @click="onDialogWithData(scope,'orderProduct')"
                  >查看下单商品</el-button>
                  <el-button
                    type="text"
                    size="small"
                    @click="onDialogWithData(scope,'excel')"
                  >生成excel</el-button>

                  <el-button type="text" size="small" @click="onDialogWithData(scope,'edit')">编辑</el-button>
                  <el-button type="text" size="small" @click="onDialogWithData(scope,'delete')">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div style="margin-top:20px;">
            <el-pagination
              background
              :page-size="20"
              :current-page.sync="currentPage"
              layout="prev, pager, next"
              :total="tableDataTotal"
              @current-change="onFetchTableData"
            ></el-pagination>
          </div>

          <!-- <div style="text-align:right;width:100%">
            <div
              style="color:#1bb24b; text-decoration: underline;cursor:pointer"
              @click="onDialogBoolDownloadAllExcelOpen()"
            ></div>
          </div>-->
        </div>
      </div>


      <!-- order product -->
      <div
        v-if="boolOrderProduct"
        class="Rectangle-5"
        v-bind:style="{ height:  + (windowHeight-200) + 'px' }"
      >
        <div style="padding:3%;">
          <div style>
            <div style="display:inline-block;width:70%;">
              <el-date-picker
                v-model="searchDate"
                value-format="yyyy-MM-dd"
                style="display:inline-block;vertical-align:middle;"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
              <!-- <el-input
                style="display:inline-block;width:35%;margin-left:10px;vertical-align:middle"
                v-model="searchProductKeyword"
                placeholder="请输入产品名称"
                @keyup.enter.native="onSearchOrderData"
              ></el-input> -->
              <el-button
                @click="onSearchOrderData"
                style="display:inline-block;margin-left:20px;background-color:#1bb24b"
                type="success"
              >搜索</el-button>
            </div>
            <div style="display:inline-block;text-align:right;width:30%"></div>
          </div>

          <div style="margin-top:3%;">
            <el-table
              :data="orderProductList"
              :height="windowHeight-450"
              style="width: 100%"
              stripe
            >
              <el-table-column prop="id" label="商品ID" sortable width="100"></el-table-column>
              <el-table-column prop="title" label="商品名称" width="200"></el-table-column>

              <el-table-column label="商品图片">
                <template slot-scope="scope">
                  <img
                    v-if="scope.row.imgUrls != undefined"
                    style="width:80px;height:80px;"
                    :src="scope.row.imgUrls[0]"
                  />
                </template>
              </el-table-column>
              <el-table-column prop="price" label="商品价格" width="200"></el-table-column>
              <el-table-column prop="buyNum" label="购买数量"></el-table-column>
            </el-table>
          </div>

          <!-- <div style="text-align:right;width:100%">
            <div
              style="color:#1bb24b; text-decoration: underline;cursor:pointer;margin-top:20px;"
              @click="onDialogBoolExcelOpen()"
            >导出Excel</div>
          </div>-->
        </div>
      </div>

      <el-dialog
        title="店铺操作"
        :visible.sync="boolAddNew"
        width="50%"
        style="text-align:left"
        :before-close="onDialogboolAddNewClose"
      >
        <div>
          <div style="display:inline-block;text-align:left;width:10%;">店铺名称</div>
          <el-input
            style="display:inline-block;width:70%;"
            v-model="form.name"
            placeholder="请输入店铺名称"
          ></el-input>
        </div>

        <div style="margin-top:20px;">
          <div style="display:inline-block;text-align:left;width:10%;">电话</div>
          <el-input
            style="display:inline-block;width:70%;"
            v-model="form.phone"
            placeholder="请输入电话"
          ></el-input>
        </div>

        <div style="margin-top:20px;">
          <div style="display:inline-block;text-align:left;width:10%;">地址</div>
          <el-input
            style="display:inline-block;width:70%;"
            v-model="form.address"
            placeholder="请输入地址"
          ></el-input>
        </div>

        <div style="text-align:right;margin-top:20px;">
          <el-button
            v-if="boolEdit"
            @click="onEditConfirm()"
            style="display:inline-block;margin-left:20px;background-color:#1bb24b;width:125px;"
            type="success"
          >确认</el-button>
          <el-button
            v-if="boolEdit ==false"
            @click="onAddNewConfirm()"
            style="display:inline-block;margin-left:20px;background-color:#1bb24b;width:125px;"
            type="success"
          >确认</el-button>
          <el-button
            @click="onDialogboolAddNewClose()"
            style="color:#1bb24b;border-color:#1bb24b;width:125px;"
          >取消</el-button>
        </div>
      </el-dialog>

      <el-dialog
        title="删除店铺"
        :visible.sync="boolDelete"
        width="50%"
        style="text-align:left"
        :before-close="onDialogBoolDeleteClose"
      >
        <div style="text-align:right;margin-top:20px;">
          <el-button
            @click="onDeleteConfirm()"
            style="display:inline-block;margin-left:20px;background-color:#1bb24b;width:125px;"
            type="success"
          >确认</el-button>
          <el-button
            @click="onDialogBoolDeleteClose()"
            style="color:#1bb24b;border-color:#1bb24b;width:125px;"
          >取消</el-button>
        </div>
      </el-dialog>

      <el-dialog
        title="生成Excel"
        :visible.sync="boolExcel"
        width="50%"
        style="text-align:left"
        :before-close="onDialogBoolExcelClose"
      >
        <div v-if="excelData.length == 0">选择的日期下没有需要订购的商品（即为，没有用户在这一天下单需要送货的商品）</div>
        <div style="text-align:right;margin-top:20px;">
          <download-excel
            v-if="excelData.length != 0"
            :name="excelName"
            style="display:inline-block;"
            :data="excelData"
          >
            <el-button
              style="display:inline-block;margin-right:20px;background-color:#1bb24b;width:125px;"
              type="success"
            >下载</el-button>
          </download-excel>

          <el-button
            @click="onDialogBoolExcelClose()"
            style="color:#1bb24b;border-color:#1bb24b;width:125px;"
          >关闭</el-button>
        </div>
      </el-dialog>

      
    </div>
  </div>
</template>

<script>
export default {
  name: "shopList",
  data() {
    return {
      fullscreenLoading: false,
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,

      boolExcel: false,
      excelData: [],
      excelName: "",

      searchKeyword: "",
      searchAllDate: [
        new Date().getFullYear() +
          "-" +
          (new Date().getMonth() + 1) +
          "-" +
          new Date().getDate(),
        new Date().getFullYear() +
          "-" +
          (new Date().getMonth() + 1) +
          "-" +
          new Date().getDate(),
      ],

      shopList: [],
      searchProductKeyword:"",

      currentData: {},
      currentPage: 1,

      tableDataList: [],
      tableDataTotal: 0,
      boolAddNew: false,
      boolEdit: false,
      boolDelete: false,
      boolOrderProduct: false,

      form: {
        name: "",
        phone: "",
        address: "",
      },

      orderProductList: [],
      searchDate: [
        new Date().getFullYear() +
          "-" +
          (new Date().getMonth() + 1) +
          "-" +
          new Date().getDate(),
        new Date().getFullYear() +
          "-" +
          (new Date().getMonth() + 1) +
          "-" +
          new Date().getDate(),
      ],
    };
  },
  mounted() {},
  created() {
    // console.log()
    this.onCheckloginRole();
    this.onFetchTableData();
    this.onFetchShopData();
  },
  methods: {
    // check if  login
    onCheckloginRole() {
      // var temp = localStorage.getItem("auth");
      // if (temp == undefined || temp != "b60afdc1f3657130c165d32743603a59") {
      //   this.$router.push("/login");
      // }
       var temp = localStorage.getItem("auth");
      this.axios.post(this.$urlGlobal + "adminCheck", {
        auth: temp
      }).then((res) => {
        if (res.data.code == -1) {
          this.$router.push("/login");
          localStorage.removeItem("auth");
      window.location.reload();
        }
      });
    },

    // search  table by name
    onSearchTableData() {
      console.log(this.searchAllDate);
      // init the page and fetch data
      this.currentPage = 1;
      this.onFetchTableData();
    },
    // fetch table data also with condition
    onFetchTableData() {
      this.fullscreenLoading = true;
      this.axios
        .post(this.$urlGlobal + "adminFetchShopByPage", {
          keyword: this.searchKeyword,
          page: this.currentPage,
        })
        .then((res) => {
          // console.log(res.data.data);
          this.tableDataList = res.data.data.data;
          this.tableDataTotal = res.data.data.total;
          this.fullscreenLoading = false;
        });
    },
    // fetch shop
    onFetchShopData() {
      this.fullscreenLoading = true;
      this.axios.post(this.$urlGlobal + "adminFetchShop", {}).then((res) => {
        this.shopList = res.data.data;
      });
    },
    

    // add new  operation
    onDialogboolAddNewOpen() {
      this.boolAddNew = true;
    },
    onDialogboolAddNewClose() {
      this.boolAddNew = false;
      // also close edit because they use same form
      this.boolEdit = false;
      this.form = {
        name: "",
        phone: "",
        address: "",
      };
    },
    onAddNewConfirm() {
      if (
        this.form.name == "" ||
        this.form.phone == "" ||
        this.form.address == ""
      ) {
        this.$message({
          message: "尚有未填信息",
          type: "warning",
        });
        return;
      }
      this.fullscreenLoading = true;
      this.boolAddNew = false;

      this.axios
        .post(this.$urlGlobal + "adminAddNewShop", {
          name: this.form.name,
          phone: this.form.phone,
          address: this.form.address,
        })
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == 1) {
            this.$message({
              message: "新增失败",
              type: "warning",
            });
          } else {
            this.$message({
              message: "增加成功",
              type: "success",
            });
          }
          this.onDialogboolAddNewClose();
          this.onFetchTableData();
        });
    },

    // edit  operation
    onDialogBoolEditOpen() {
      this.boolAddNew = true;
      this.boolEdit = true;
      this.form = {
        name: this.currentData.name,
        phone: this.currentData.phone,
        address: this.currentData.address,
      };
    },
    onEditConfirm() {
      if (
        this.form.name == "" ||
        this.form.phone == "" ||
        this.form.address == ""
      ) {
        this.$message({
          message: "尚有未填信息",
          type: "warning",
        });
        return;
      }
      this.fullscreenLoading = true;
      this.axios
        .post(this.$urlGlobal + "adminEditShop", {
          id: this.currentData.id,
          name: this.form.name,
          phone: this.form.phone,
          address: this.form.address,
        })
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == 1) {
            this.$message({
              message: "修改失败",
              type: "warning",
            });
            return;
          } else {
            this.$message({
              message: "修改成功",
              type: "success",
            });
          }
          this.onDialogboolAddNewClose();
          this.onFetchTableData();
        });
    },

    // delete  operation
    onDialogBoolDeleteOpen() {
      this.boolDelete = true;
    },
    onDialogBoolDeleteClose() {
      this.boolDelete = false;
    },
    onDeleteConfirm() {
      this.fullscreenLoading = true;
      this.axios
        .post(this.$urlGlobal + "adminDeleteShop", {
          id: this.currentData.id,
        })
        .then((res) => {
          this.fullscreenLoading = false;
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.onDialogBoolDeleteClose();
          this.onFetchTableData();
        });
    },

    // table operation
    onDialogWithData(scope, e) {
      this.currentData = scope.row;
      switch (e) {
        case "excel":
          this.onDialogBoolExcelSignalOpen();
          break;
        case "orderProduct":
          this.onDialogBoolOrderProductOpen();
          break;
        case "edit":
          this.onDialogBoolEditOpen();
          break;
        case "delete":
          this.onDialogBoolDeleteOpen();
          break;
      }
    },

    onSearchOrderData() {
      this.onDialogBoolOrderProductOpen();
    },

    onDialogBoolExcelSignalOpen() {
      this.fullscreenLoading = true;
      var startTime = "";
      var endTime = "";
      if (this.searchAllDate != null && this.searchAllDate.length > 0) {
        startTime = this.searchAllDate[0];
        endTime = this.searchAllDate[1];
      }
      this.axios
        .post(this.$urlGlobal + "adminFetchOrder", {
          deliveryStart: startTime,
          deliveryEnd: endTime,
          perPage: false,
          status: ["待配送"],
        })
        .then((res) => {
          this.fullscreenLoading = false;
          var temp = [];
          for (var i = 0; i < res.data.data.length; i++) {
            for (var n = 0; n < res.data.data[i].orderDetail.length; n++) {
              if (
                res.data.data[i].orderDetail[n].belongShopId ==
                this.currentData.id
              ) {
                temp.push(res.data.data[i].orderDetail[n]);
              }
            }
          }
          var final = [];
          for (var i = 0; i < temp.length; i++) {
            var ifInside = false;
            for (var n = 0; n < final.length; n++) {
              if (temp[i].id == final[n].id) {
                ifInside = true;
                final[n].buyNum = parseInt(final[n].buyNum);
                final[n].buyNum += parseInt(temp[i].buyNum);
              }
            }

            if (!ifInside) {
              final.push(temp[i]);
            }
          }
          console.log(this.tableDataList);
          this.orderProductList = final;
          this.onDialogBoolExcelOpen();
        });
    },

    // order product
    onDialogBoolOrderProductOpen() {
      this.boolOrderProduct = true;
      this.fullscreenLoading = true;

      var startTime = "";
      var endTime = "";
      if (this.searchDate != null && this.searchDate.length > 0) {
        startTime = this.searchDate[0];
        endTime = this.searchDate[1];
      }
      this.axios
        .post(this.$urlGlobal + "adminFetchOrder", {
          deliveryStart: startTime,
          deliveryEnd: endTime,
          perPage: false,
          status: ["待配送"],
        })
        .then((res) => {
          this.fullscreenLoading = false;
          var temp = [];
          for (var i = 0; i < res.data.data.length; i++) {
            for (var n = 0; n < res.data.data[i].orderDetail.length; n++) {
              if (
                res.data.data[i].orderDetail[n].belongShopId ==
                this.currentData.id
              ) {
                temp.push(res.data.data[i].orderDetail[n]);
              }
            }
          }
          var final = [];
          for (var i = 0; i < temp.length; i++) {
            var ifInside = false;
            for (var n = 0; n < final.length; n++) {
              if (temp[i].id == final[n].id) {
                ifInside = true;
                final[n].buyNum = parseInt(final[n].buyNum);
                final[n].buyNum += parseInt(temp[i].buyNum);
              }
            }

            if (!ifInside) {
              final.push(temp[i]);
            }
          }
          console.log(this.tableDataList);
          this.orderProductList = final;
        });
    },

    onGoTo(e) {
      switch (e) {
        case "home":
          this.boolOrderProduct = false;
          break;
      }
    },

    onDialogBoolExcelOpen() {
      this.excelData = [];
      this.boolExcel = true;
      var startTime = "";
      var endTime = "";
      if (this.searchAllDate != null && this.searchAllDate.length > 0) {
        startTime = this.searchAllDate[0];
        endTime = this.searchAllDate[1];
      }
      var temp = [];
      for (var i = 0; i < this.orderProductList.length; i++) {
        if (i == 0) {
          temp.push({
            送货时间: this.searchAllDate[0] + "至" + this.searchAllDate[1],
            供货商名: this.currentData.name,
            电话: this.currentData.phone,
            地址: this.currentData.address,
            品号: this.orderProductList[i].id,
            品名: this.orderProductList[i].title,
            规格: this.orderProductList[i].unit,
            下单数量: parseInt(this.orderProductList[i].buyNum),
          });
        } else {
          temp.push({
            品号: this.orderProductList[i].id,
            品名: this.orderProductList[i].title,
            规格: this.orderProductList[i].unit,
            下单数量: parseInt(this.orderProductList[i].buyNum),
          });
        }
      }
      var d = new Date();
      var n = d.getDate();
      var y = d.getFullYear();
      var m = d.getMonth() + 1;
      this.excelName =
        "freshgo " + this.currentData.name + " " + startTime + "至" + endTime;
      // this.excelName = this.currentData.name;
      this.excelData = temp;
    },
    // excel operation
    onDialogBoolExcelClose() {
      this.boolExcel = false;
      this.excelData = [];
    },

    onDialogBoolDownloadAllExcelOpen() {
      this.excelData = [];
      var startTime = "";
      var endTime = "";
      if (this.searchAllDate != null && this.searchAllDate.length > 0) {
        startTime = this.searchAllDate[0];
        endTime = this.searchAllDate[1];
      }
      this.fullscreenLoading = true;
      this.axios
        .post(this.$urlGlobal + "adminFetchOrder", {
          deliveryStart: startTime,
          deliveryEnd: endTime,
          perPage: false,
          status: ["待配送"],
        })
        .then((res) => {
          this.fullscreenLoading = false;
          this.boolExcel = true;

          var shopTemp = [];
          var productTemp = [];
          for (var i = 0; i < res.data.data.length; i++) {
            for (var n = 0; n < res.data.data[i].orderDetail.length; n++) {
              if (
                !shopTemp.includes(res.data.data[i].orderDetail[n].belongShopId)
              ) {
                shopTemp.push(res.data.data[i].orderDetail[n].belongShopId);
              }
              productTemp.push(res.data.data[i].orderDetail[n]);
            }
          }

          // merge productTemp
          var productFinal = [];
          for (var i = 0; i < productTemp.length; i++) {
            var bool = false;
            for (var n = 0; n < productFinal.length; n++) {
              if (productFinal[n].id == productTemp[i].id) {
                bool = true;
                productFinal[n].buyNum = parseInt(productFinal[n].buyNum);
                productFinal[n].buyNum += parseInt(productTemp[i].buyNum);
                break;
              }
            }
            if (!bool) {
              productFinal.push(productTemp[i]);
            }
          }

          var shopProductList = [];
          for (var i = 0; i < shopTemp.length; i++) {
            var temp = [];
            for (var n = 0; n < productFinal.length; n++) {
              if (productFinal[n].belongShopId == shopTemp[i]) {
                temp.push(productFinal[n]);
              }
            }

            var shopDetail = null;
            for (var n = 0; n < this.shopList.length; n++) {
              if (this.shopList[n].id == shopTemp[i]) {
                shopDetail = this.shopList[n];
                break;
              }
            }

            shopProductList.push({ shop: shopDetail, product: temp });
          }

          var temp = [];
          for (var i = 0; i < shopProductList.length; i++) {
            for (var n = 0; n < shopProductList[i].product.length; n++) {
              if (n == 0) {
                temp.push({
                  送货时间:
                    this.searchAllDate[0] + "至" + this.searchAllDate[1],
                  供货商名: shopProductList[i].shop.name,
                  电话: shopProductList[i].shop.phone,
                  地址: shopProductList[i].shop.address,
                  品号: shopProductList[i].product[n].id,
                  品名: shopProductList[i].product[n].title,
                  规格: shopProductList[i].product[n].unit,
                  下单数量: parseInt(shopProductList[i].product[n].buyNum),
                });
              } else {
                temp.push({
                  品号: shopProductList[i].product[n].id,
                  品名: shopProductList[i].product[n].title,
                  规格: shopProductList[i].product[n].unit,
                  下单数量: parseInt(shopProductList[i].product[n].buyNum),
                });
              }
            }
            // temp.push({});
          }

          console.log(temp);
          // if (temp.length == 0) {
          //   this.$message({
          //     message: "在选择的时间下没有任何货物需求",
          //     type: "warning"
          //   });
          // }
          var d = new Date();
          var n = d.getDate();
          var y = d.getFullYear();
          var m = d.getMonth() + 1;
          this.excelName = "freshgo 进货总单" + startTime + "至" + endTime;
          this.excelData = temp;
          // console.log(shopProductList);
        });
    },
  },
};
</script>

